// Class names for V2 elements. Every class is "mc" or "mc-*" (the scoping rule, plan §1.2): V1's class rules never
// match a V2 element, and a V2 rule never matches a V1 one. In development an unprefixed class throws, naming it.

export type ClassPart = string | false | null | undefined | 0;

export function cx(...parts: ClassPart[]): string {
  const classes = parts.filter((part): part is string => typeof part === "string" && part.trim() !== "")
    .flatMap((part) => part.trim().split(/\s+/));
  if (import.meta.env.DEV) {
    for (const name of classes) {
      if (name !== "mc" && !name.startsWith("mc-")) throw new Error(`cx: class "${name}" is not mc-* (V2 classes are prefixed)`);
    }
  }
  return classes.join(" ");
}
